import {gql} from '@apollo/client';

import {
  InAppNotificationListingQuery as InAppNotificationListingQueryData,
  InAppNotificationListingQueryVariables,
} from './__generated/InAppNotificationListingQuery';
import {InAppNotificationUnreadSummaryQuery as InAppNotificationUnreadSummaryQueryData} from './__generated/InAppNotificationUnreadSummaryQuery';

// The types above are generated from the `gql` documents in this file by `dev generate frontend`.
// These documents are the source codegen reads; edit them here and regenerate to update the types.
export type {
  InAppNotificationListingQueryData,
  InAppNotificationListingQueryVariables,
  InAppNotificationUnreadSummaryQueryData,
};

// One notification as returned by `inAppNotificationListing`. Selects every field on
// `InAppNotificationNode`; `resourceApiId`/`actorApiId` are fetched for future link derivation even
// though V1 renders the body as plain text.
export const IN_APP_NOTIFICATION_FRAGMENT = gql`
  fragment InAppNotificationFields on InAppNotificationNode {
    id
    status
    title
    body
    actorApiId
    resourceApiId
    lastEventAt
    readAt
    dismissedAt
  }
`;

export const IN_APP_NOTIFICATION_LISTING_QUERY = gql`
  query InAppNotificationListingQuery(
    $pageSize: StrictInt
    $nextToken: StrictString
    $statuses: [InAppNotificationStatus!]
  ) @skipAudit @engComponent(name: NOTIFICATIONS) {
    inAppNotificationListing(pageSize: $pageSize, nextToken: $nextToken, statuses: $statuses) {
      items {
        ...InAppNotificationFields
      }
      nextToken
    }
  }
  ${IN_APP_NOTIFICATION_FRAGMENT}
`;

export const IN_APP_NOTIFICATION_UNREAD_SUMMARY_QUERY = gql`
  query InAppNotificationUnreadSummaryQuery @skipAudit @engComponent(name: NOTIFICATIONS) {
    inAppNotificationUnreadSummary {
      unreadCount
      latestEventAt
    }
  }
`;
